export const HEADING_DIV = {
  init: function (elements) {
    $('h2.wp-block-heading').wrap('<div class="c-heading__level2-box">')
  },
}
